import React from 'react';
import styled from 'styled-components';
import LightButton from '~/editor/buttons/LightButton';
import AiIcon from '~/assets/button/ai_b.png';

const Container = styled.div<{ variant?: 'ai' }>`
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 10px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${props => (props.variant === 'ai' ? '10px' : '0')};

  button {
    background: #9738ff;
    color: #fff;
    cursor: pointer;
    white-space: nowrap;
    min-width: ${props => (props.variant === 'ai' ? '200px' : 'auto')};
  }

  input[type='text'] {
    flex: 1 1 200px;
    min-width: 0;
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    background-color: #f5f5f5;
    color: #6f6f6f;
    font-family: Raleway;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    ${props =>
      props.variant === 'ai' &&
      `
      background-image: url(${AiIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
      padding-left: 40px;
    `}
  }

  select {
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    background-color: #f5f5f5;
    color: #6f6f6f;
    font-family: Raleway;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
  }

  p {
    padding-left: 20px;
    font-family: Raleway;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #6f6f6f;
  }
`;

type SearchHeaderProps = {
  variant?: 'ai';
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
  loading?: boolean;
  loadingText?: string;
  style?: string;
  onStyleChange?: (style: string) => void;
};

const SearchHeader: React.FC<SearchHeaderProps> = ({
  variant,
  placeholder,
  value,
  onChange,
  onSearch,
  loading,
  loadingText,
  style,
  onStyleChange
}) => {
  return (
    <Container variant={variant}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      {variant === 'ai' && (
        <>
          <select value={style} onChange={e => onStyleChange?.(e.target.value)}>
            <option value="natural">Natural Style</option>
            <option value="vivid">Vivid Style</option>
          </select>
          <LightButton onClick={onSearch} disabled={!value || loading}>
            {loading ? loadingText : 'Generate image'}
          </LightButton>
        </>
      )}
    </Container>
  );
};

export default SearchHeader;
